/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addNewItemsToCurrentOrderList } from '../fn/order-lists/add-new-items-to-current-order-list';
import { AddNewItemsToCurrentOrderList$Params } from '../fn/order-lists/add-new-items-to-current-order-list';
import { deleteItemFormCurrentOrderList } from '../fn/order-lists/delete-item-form-current-order-list';
import { DeleteItemFormCurrentOrderList$Params } from '../fn/order-lists/delete-item-form-current-order-list';
import { deleteItemsFormCurrentOrderList } from '../fn/order-lists/delete-items-form-current-order-list';
import { DeleteItemsFormCurrentOrderList$Params } from '../fn/order-lists/delete-items-form-current-order-list';
import { getCurrentOrderListItems } from '../fn/order-lists/get-current-order-list-items';
import { GetCurrentOrderListItems$Params } from '../fn/order-lists/get-current-order-list-items';
import { OrderListItemCreateResponse } from '../models/order-list-item-create-response';
import { PageOrderListItemResponse } from '../models/page-order-list-item-response';
import { updateCurrentOrderListItemQuantity } from '../fn/order-lists/update-current-order-list-item-quantity';
import { UpdateCurrentOrderListItemQuantity$Params } from '../fn/order-lists/update-current-order-list-item-quantity';
import { updateOrderListItemsQuantityBulk } from '../fn/order-lists/update-order-list-items-quantity-bulk';
import { UpdateOrderListItemsQuantityBulk$Params } from '../fn/order-lists/update-order-list-items-quantity-bulk';


/**
 * Order list management endpoints. All operations require PRODUCT_ADMIN role.
 */
@Injectable({ providedIn: 'root' })
export class OrderListsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateCurrentOrderListItemQuantity()` */
  static readonly UpdateCurrentOrderListItemQuantityPath = '/order-lists/current/items/{itemId}';

  /**
   * Updates current order list item's quantity.
   *
   * Updates an existing item based on its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCurrentOrderListItemQuantity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCurrentOrderListItemQuantity$Response(params: UpdateCurrentOrderListItemQuantity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateCurrentOrderListItemQuantity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates current order list item's quantity.
   *
   * Updates an existing item based on its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCurrentOrderListItemQuantity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCurrentOrderListItemQuantity(params: UpdateCurrentOrderListItemQuantity$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateCurrentOrderListItemQuantity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteItemFormCurrentOrderList()` */
  static readonly DeleteItemFormCurrentOrderListPath = '/order-lists/current/items/{itemId}';

  /**
   * Delete item from the current order list.
   *
   * Delete specified item.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteItemFormCurrentOrderList()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteItemFormCurrentOrderList$Response(params: DeleteItemFormCurrentOrderList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteItemFormCurrentOrderList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete item from the current order list.
   *
   * Delete specified item.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteItemFormCurrentOrderList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteItemFormCurrentOrderList(params: DeleteItemFormCurrentOrderList$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteItemFormCurrentOrderList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOrderListItemsQuantityBulk()` */
  static readonly UpdateOrderListItemsQuantityBulkPath = '/order-lists/current/items/bulk';

  /**
   * Updates quantities for current order list items in bulk.
   *
   * Items are deleted where quantity is 0.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOrderListItemsQuantityBulk()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrderListItemsQuantityBulk$Response(params: UpdateOrderListItemsQuantityBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateOrderListItemsQuantityBulk(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates quantities for current order list items in bulk.
   *
   * Items are deleted where quantity is 0.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOrderListItemsQuantityBulk$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrderListItemsQuantityBulk(params: UpdateOrderListItemsQuantityBulk$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateOrderListItemsQuantityBulk$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCurrentOrderListItems()` */
  static readonly GetCurrentOrderListItemsPath = '/order-lists/current/items';

  /**
   * Gets items of the current order list.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentOrderListItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentOrderListItems$Response(params?: GetCurrentOrderListItems$Params, context?: HttpContext): Observable<StrictHttpResponse<PageOrderListItemResponse>> {
    const obs = getCurrentOrderListItems(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets items of the current order list.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentOrderListItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentOrderListItems(params?: GetCurrentOrderListItems$Params, context?: HttpContext): Observable<PageOrderListItemResponse> {
    const resp = this.getCurrentOrderListItems$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageOrderListItemResponse>): PageOrderListItemResponse => r.body)
    );
  }

  /** Path part for operation `addNewItemsToCurrentOrderList()` */
  static readonly AddNewItemsToCurrentOrderListPath = '/order-lists/current/items';

  /**
   * Add items to the current order list.
   *
   * Creates a new items and add it to the current order list.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addNewItemsToCurrentOrderList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewItemsToCurrentOrderList$Response(params: AddNewItemsToCurrentOrderList$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderListItemCreateResponse>> {
    const obs = addNewItemsToCurrentOrderList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add items to the current order list.
   *
   * Creates a new items and add it to the current order list.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addNewItemsToCurrentOrderList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addNewItemsToCurrentOrderList(params: AddNewItemsToCurrentOrderList$Params, context?: HttpContext): Observable<OrderListItemCreateResponse> {
    const resp = this.addNewItemsToCurrentOrderList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderListItemCreateResponse>): OrderListItemCreateResponse => r.body)
    );
  }

  /** Path part for operation `deleteItemsFormCurrentOrderList()` */
  static readonly DeleteItemsFormCurrentOrderListPath = '/order-lists/current/items';

  /**
   * Delete items from the current order list.
   *
   * Delete specified items.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteItemsFormCurrentOrderList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteItemsFormCurrentOrderList$Response(params: DeleteItemsFormCurrentOrderList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteItemsFormCurrentOrderList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete items from the current order list.
   *
   * Delete specified items.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteItemsFormCurrentOrderList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteItemsFormCurrentOrderList(params: DeleteItemsFormCurrentOrderList$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteItemsFormCurrentOrderList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
